/**************************************************************************************************/
/*   File: /src/app/shared/components/breadcrumb/breadcrumb.component.ts                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Component, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import * as fromActions from '../../../stores/actions';
import * as fromModels from '../../models';
import { RouterReducerState } from '@ngrx/router-store';

/**
 * The breadcrumb component
 */
@Component({
    selector: 'nwpl-frnt-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnChanges {
    /**
     * The currentLanguage
     * @type {fromModels.Language}
     */
    @Input() currentLanguage: fromModels.Language;
    /**
     * The router state
     * @type {RouterReducerState}
     */
    @Input() routerState: RouterReducerState;
    /**
     * The show from external
     * @type {boolean}
     */
    @Input() show: boolean;
    /**
     * The jumped event emitter
     * @type {EventEmitter<Array<string>>}
     */
    @Output() jumped: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();
    /**
     * The breadcrumb fragments
     * @type {fromModels.BreadcrumbFragment[]}
     */
    breadcrumbFragments: fromModels.BreadcrumbFragment[];

    /**
     * Construct the breadcrumb component
     */
    constructor() { }
    /**
     * The ng on changes hook
     * @param {SimpleChanges} changes The changes on input
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.routerState && changes.routerState.currentValue) {
            this.parseState(changes.routerState.currentValue);
        }
    }
    /**
     * Go to path
     * @param {Event} $event the event
     * @param {string[]} path Th path array
     */
    goTo($event: Event, path: string[]) {
        $event.preventDefault();
        this.jumped.emit(path);
    }
    /**
     * The home navigation
     * @param {Event} $event The event
     */
    goToHome($event: Event) {
        $event.preventDefault();
        this.jumped.emit(['shell', 'authorization']);
    }
    /**
     * Set the breadcrumb according to state
     * @param {RouterReducerState} state The router state
     */
    parseState(state: RouterReducerState) {
        // Reinitialize breadgrumbs framment array
        this.breadcrumbFragments = [];

        // Get the app component
        // It cannot be null but it's required for test
        // FIX
        /* istanbul ignore next */
        if (state &&
            state.state &&
            state.state.root &&
            state.state.root.children &&
            state.state.root.children.length > 0) {

            this.breadcrumbFragments = this.navigateStructure(state.state.root, this.breadcrumbFragments);
        }
    }
    /**
     * Extract fragments from router state initializing breadcrumb fragment array
     * @param {ActivatedRouteSnapshot[]} children The children array
     * @param {fromModels.BreadcrumbFragment[]} fragments The fragments of breadcrumb
     */
    navigateStructure(child: ActivatedRouteSnapshot, fragments: fromModels.BreadcrumbFragment[]) {

        /* children.forEach((child: ActivatedRouteSnapshot) => {
            if (child.data) {
                console.warn(child.data);
                /*  const fragment = new fromModels.BreadcrumbFragment();
                 fragment.key = child.data.key;
                 console.log(child.url);
                 fragments.push(fragment);
            }


        }); */
        /* istanbul ignore next */
        if (child.children.length > 0) {
            if (child.url.length > 0) {
                let urls = [];
                if (fragments && fragments.length > 0) {
                    urls = urls.concat(fragments[fragments.length - 1].path);
                }

                if (child.url && child.url.length > 0) {
                    urls.push(child.url[0].path);
                }

                if (child.url && child.url.length > 0) {
                    const breadcrumbFragment = new fromModels.BreadcrumbFragment();
                    breadcrumbFragment.key =  child.url[0].path;
                    breadcrumbFragment.path = urls;

                    fragments.push(breadcrumbFragment);
                }
            }

            child.children.forEach((currentChild: ActivatedRouteSnapshot) => {
                return this.navigateStructure(currentChild, fragments);
            });
        } else {

            let urls = [];

            if (fragments && fragments.length > 0) {
                urls = urls.concat(fragments[fragments.length - 1].path);
            }

            if (child.url && child.url.length > 0) {
                urls.push(child.url[0].path);
                const breadcrumbFragment = new fromModels.BreadcrumbFragment();
                breadcrumbFragment.key = child.url && child.url.length > 0 ? child.url[0].path : '';
                breadcrumbFragment.path = urls;
    
                fragments.push(breadcrumbFragment);
            }

        }
        return fragments;
    }
}